import * as actions from "Actions";
import * as api from "Api";

export const fetchSuperCategoriesSuggestions = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getSuperCategoriesSuggestions(
        api.getSuperCategoriesSuggestions(currentOrganization.id)
      )
    );
  };
};

export const fetchSuperCategoriesSettings = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getSuperCategoriesSuggestions(
        api.getSuperCategoriesSuggestions(currentOrganization.id)
      )
    );
  };
};

export const updateSuperCategorySettings = (categoryId, labels) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.updateSuperCategorySettings(
      api.updateSuperCategorySettings({
        organization: currentOrganization.id,
        id: categoryId,
        labels: labels
      })
    )
  );
};

export const deleteSuperCategorySettings = (categoryId, isForced) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteSuperCategorySettings(
      api.deleteSuperCategorySettings({
        organization: currentOrganization.id,
        isForced: isForced,
        id: categoryId
      })
    )
  );
};

export const saveSuperCategorySettings = labels => (dispatch, getState) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveSuperCategorySettings(
      api.saveSuperCategorySettings({
        organization: currentOrganization.id,
        labels: labels
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/super-categories.js